export const PRIVACY_POLICY_DATA = {
    // companyInfo: {
    //     name: "Money Rate Finder",
    //     controller: "ATMARDS MARKETING LLP",
    //     email: "Product@upgrowthmarketing.in",
    //     address: "First Floor, C133",
    //   },
    //   privacyNotice: {
    //     description: `
    //       Privacy Notice for Money Rate Finder (“we,” “us,” or “our”), describes how and why we might access, collect, store, use, and/or share (“process”) your personal information when you use our services (“Services”), including when you:
    //     `,
    //     points: [
    //       "Download and use our mobile application (Money Rate Finder), or any other application of ours that links to this Privacy Notice",
    //       "Use Money Rate Finder. __________",
    //       "Engage with us in other related ways, including any sales, marketing, or events",
    //     ],
    //     questions: `
    //       Questions or concerns? Reading this Privacy Notice will help you understand your privacy rights and choices. We are responsible for making decisions about how your personal information is processed. If you do not agree with our policies and practices, please do not use our Services. If you still have any questions or concerns, please contact us at <a href="mailto:product@upgrowthmarketing.in">product@upgrowthmarketing.in</a>.
    //     `,
    //     summaryTitle: "SUMMARY OF KEY POINTS",
    //     summarized_data: [
    //       "This summary provides key points from our Privacy Notice, but you can find out more details about any of these topics by clicking the link following each key point below to find the section you are looking for.",
    //       "What personal information do we process? When you visit, use, or navigate our Services, we may process personal information depending on how you interact with us and the Services, the choices you make, and the products and features.",
    //       "Do we process any sensitive personal information? Some of the information may be considered “special” or “sensitive” in certain jurisdictions, for example, your racial or ethnic origins, sexual orientation, and religious beliefs. We do not process sensitive personal information.",
    //       "Do we collect any information from third parties? We do not collect any information from third parties.",
    //       "How do we process your information? We process your information to provide, improve, and administer our Services, communicate with you, for security and fraud prevention, and to comply with the law. We may also process your information for other purposes with your consent. We process your information only when we have a valid legal reason to do so.",
    //       "In what situations and with which types of parties do we share personal information? We may share information in specific situations and with specific categories of third parties.",
    //       "How do we keep your information safe? We have adequate organizational and technical processes and procedures in place to protect your personal information. However, no electronic transmission over the internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other unauthorized third parties will not be able to defeat our security and improperly collect, access, steal, or modify your information.",
    //       "What are your rights? Depending on where you are located geographically, the applicable privacy law may mean you have certain rights regarding your personal information.",
    //     ],
    //   },
    // dataCollection: {
    //     personalData: [
    //         { title: <>
    //         <h1>Personal information you disclose to us</h1>
    //         <h2>In Short: We collect personal information that you provide to us.</h2>
    //         <h2>We collect personal information that you voluntarily provide to us when you register on the Services, express an interest in obtaining information about us or our products and Services, when you participate in activities on the Services, or otherwise when you contact us.</h2>
    //         <h2>Personal Information Provided by You. The personal information that we collect depends on the context of your interactions with us and the Services, the choices you make, and the products and features you use. The personal information we collect may include the following:</h2>
    //         <ul className="list-disc list-inside">
    //             <li>Phone numbers</li>
    //             <li>Email addresses</li>
    //             <li>Names</li>
    //         </ul>
    //         <p>Sensitive Information. We do not process sensitive information.</p>
    //         <p>Application Data.</p>
    //         <p>
    //         If you use our application(s), we also may collect the following information if you choose to provide us with access or permission:
    //         </p>
    //         <ul className="list-disc list-inside">
    //             <li>Push Notifications. We may request to send you push notifications regarding your account or certain features of the application(s). If you wish to opt out of receiving these types of communications, you may turn them off in your device’s settings.</li>
    //         </ul>
    //         <p>This information is primarily needed to maintain the security and operation of our application(s), for troubleshooting, and for our internal analytics and reporting purposes.</p>
    //         <p>All personal information that you provide to us must be true, complete, and accurate, and you must notify us of any changes to such personal information.</p>
    //         </>}
    //     ]
    // },
    // dataUsage: {
    //     legalGrounds: [
    //         {
    //             title: <>
    //             <h1>In Short: We process your information to provide, improve, and administer our Services, communicate with you, for security and fraud prevention, and to comply with the law. We may also process your information for other purposes with your consent.
    //             </h1>
    //             <h1>We process your personal information for a variety of reasons, depending on how you interact with our Services, including:</h1>
    //             <ul className="list-disc list-inside">
    //                 <li>To facilitate account creation and authentication and otherwise manage user accounts.</li>
    //                 <li>To fulfill and manage your orders, payments, returns, and exchanges.</li>
    //                 <li>To identify usage trends for service improvements.</li>
    //             </ul>
    //             </>,
    //         }
    //     ]
    // },
    // dataSharing: {
    //     parties: [
    //         {
    //             title: <>
    //             <h1>In Short: We may share information in specific situations described in this section and/or with the following categories of third parties.</h1>
    //             <h1>Vendors, Consultants, and Other Third-Party Service Providers. We may share your data with third-party vendors, service providers, contractors, or agents (“third parties”) who perform services for us or on our behalf.</h1>
    //             <h1>The categories of third parties we may share personal information with include:</h1>
    //             <ul className="list-disc list-inside">
    //                 <li>Data Analytics Services</li>
    //             </ul>
    //             </>,
    //         }
    //     ],
    //     note: "We ensure that data is only shared under strict confidentiality and security agreements."
    // },
    // userRights: [
    //     { title: <>
    //     <h1>In Short: We may use cookies and other tracking technologies to collect and store your information.</h1>
    //     <h1>We may use cookies and similar tracking technologies (like web beacons and pixels) to gather information when you interact with our Services.</h1>
    //     <h1>Google Analytics</h1>
    //     <h1>We may share your information with Google Analytics to track and analyze the use of the Services.</h1>
    //     </>},
    // ],
    // aiBased: [
    //     { title: <>
    //     <h1>In Short: We offer products, features, or tools powered by artificial intelligence, machine learning, or similar technologies.</h1>
    //     </>},
    // ],
    // keepInfo: [
    //     { title: <>
    //     <h1>In Short: We keep your information for as long as necessary to fulfill the purposes outlined in this Privacy Notice unless otherwise required by law.</h1>
    //     </>},
    // ],
    // infoSafe: [
    //     { title: <>
    //     <h1>In Short: We aim to protect your personal information through a system of organizational and technical security measures.</h1>
    //     </>},
    // ],
    // privacyRights: [
    //     { title: <>
    //     <h1>In Short: You may review, change, or terminate your account at any time.</h1>
    //     <h1>If you have questions or comments about your privacy rights, you may email us at <a href="mailto:product@upgrowthmarketing.in">product@upgrowthmarketing.in</a>.</h1>
    //     </>},
    // ],
    // notTrack: [
    //     { title: <>
    //     <h1>We do not currently respond to DNT browser signals or any other mechanism that automatically communicates your choice not to be tracked online.</h1>
    //     </>},
    // ],
    // notice: [
    //     { title: <>
    //     <h1>In Short: Yes, we will update this notice as necessary to stay compliant with relevant laws.</h1>
    //     </>},
    // ],
    // contactUs: [
    //     { title: <>
    //     <h1>If you have questions or comments about this notice, you may email us at <a href="mailto:product@upgrowthmarketing.in">product@upgrowthmarketing.in</a> or contact us by post at:</h1>
    //     <ul>
    //         <li>Money Rate Finder</li>
    //         <li>C 133</li>
    //         <li>Chattarpur Enclave</li>
    //         <li>Phase 2, New Delhi - 110074</li>
    //     </ul>
    //     </>},
    // ],
    // crud: [
    //     { title: <>
    //     <h1>You have the right to request access to, update, or delete your personal information. To make a request, please contact us at<a href="mailto:product@upgrowthmarketing.in">product@upgrowthmarketing.in</a>.</h1>
    //     <h1>
    //     This Privacy Policy ensures transparency and security regarding the collection, storage, and use of user data for the Money Rate Finder app.
    //     </h1>
    //     </>},
    // ],
    privacyRights: [
        { title: <>
        <ul>
        <li class="before:content-['-'] before:mr-2 before:inline-block">We do not collect, store, or share any personal information from users.</li>
        <li class="before:content-['-'] before:mr-2 before:inline-block">We do not track your usage or behavior within the app.</li>
        </ul>
        </>},
    ],
    notTrack: [
        { title: <>
        <ul>
        <li class="before:content-['-'] before:mr-2 before:inline-block">We do not share any information with third parties because we do not collect any.</li>
        </ul>
        </>},
    ],
    notice: [
        { title: <>
        <ul>
        <li class="before:content-['-'] before:mr-2 before:inline-block">Our app does not use cookies, trackers, or any other technology to collect data.</li>
        </ul>
        </>},
    ],
    crud: [
        { title: <>
        <ul>
        <li class="before:content-['-'] before:mr-2 before:inline-block">As no data is collected, there's no personal information to protect.</li>
        </ul>
        </>},
    ],
    contactUs: [
        { title: <>
        <h1>If you have any questions about this privacy policy, please feel free to contact us:</h1>
        <h1>Email:  <a href="mailto:product@upgrowthmarketing.in" className="text-[#7B3BCC] underline">product@upgrowthmarketing.in</a></h1>
        <ul>
            <li>MoneyRateFinder</li>
            <li>C 133, Chattarpur Enclave</li>
            <li>Phase 2, New Delhi - 110074, India</li>
        </ul>
        </>},
    ],
    summarized_data:[
        "This summary provides key points from our Privacy Notice, but you can find out more details about any of these topics by clicking the link following each key point below to find the section you are looking for.",
        "What personal information do we process? When you visit, use, or navigate our Services, we may process personal information depending on how you interact with us and the Services, the choices you make, and the products and features.",
        "Do we process any sensitive personal information? Some of the information may be considered “special” or “sensitive” in certain jurisdictions, for example, your racial or ethnic origins, sexual orientation, and religious beliefs. We do not process sensitive personal information.",
        "Do we collect any information from third parties? We do not collect any information from third parties.",
        "How do we process your information? We process your information to provide, improve, and administer our Services, communicate with you, for security and fraud prevention, and to comply with the law. We may also process your information for other purposes with your consent. We process your information only when we have a valid legal reason to do so.",
        "In what situations and with which types of parties do we share personal information? We may share information in specific situations and with specific categories of third parties.",
        "How do we keep your information safe? We have adequate organizational and technical processes and procedures in place to protect your personal information. However, no electronic transmission over the internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other unauthorized third parties will not be able to defeat our security and improperly collect, access, steal, or modify your information.",
        "What are your rights? Depending on where you are located geographically, the applicable privacy law may mean you have certain rights regarding your personal information.",
    ]
    
};
